import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from '@environments/environment';

if (environment.sentry.enabled) {
  Sentry.init({
    ...environment.sentry.config,
    integrations: [Sentry.browserTracingIntegration()],
  });

  // lazy load replay integration to save some bundle size
  (async () => {
    Sentry.lazyLoadIntegration('replayIntegration').then(replayIntegration => {
      Sentry.addIntegration(replayIntegration());
    });
  })();
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
